import { render, staticRenderFns } from "./DeliveryForm.vue?vue&type=template&id=52127148&"
import script from "./DeliveryForm.vue?vue&type=script&lang=ts&"
export * from "./DeliveryForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports